import { Component, Input } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
	selector: 'drag-drop-groups',
	templateUrl: 'drag-drop-groups.component.html',
	styleUrls: ['drag-drop-groups.component.css']
})
export class DragDropGroupsComponent {
	@Input() parentContainer!: HTMLElement;
	@Input() containerClass!: string;
	@Input() listClass!: string;
	@Input() leftTitle!: string;
	@Input() rightTitle!: string;
	@Input() leftList!: any[];
	@Input() rightList!: any[];
	@Input() labelGetter!: Function;

	drop(event: CdkDragDrop<any[]>) {
		if (event.previousContainer === event.container) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			transferArrayItem(event.previousContainer.data,
				event.container.data,
				event.previousIndex,
				event.currentIndex);
		}
	}
}